exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".demo {\n  position: relative; }\n\n.demo__button {\n  width: 80px; }\n\n.sliders__label {\n  line-height: 48px;\n  width: 20px; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader!./client/app/views/demo/demo.scss
 ** module id = 49
 ** module chunks = 0
 **/